import React, { Component } from 'react'
import Header from '../components/Header'
import Card1 from '../components/cards/Card1'
import { connect } from 'react-redux';
import { changeStateValue } from '../redux/MainReducer';
import { getCompanyVAbout } from '../actions/MainAction';
export class CompanyVAbout extends Component {
  openModal=(data, lang, lang_id=1)=>{
    // console.log(lang, lang_id)
    this.props.changeStateValue({
      name:"mainModal",
      value:{
        position:true,
        id: data?.id?data?.id:"",
        // image: data?.image?data?.image:"",
        // image_full_url: data?.image_full_url?data?.image_full_url:"",
       
        languages:
          {
            id:lang?.id?lang?.id:'',
            // title:lang?.title?lang?.title:'',
            description:lang?.description?lang?.description:'',
            lang_id:lang_id
          }
        ,
        requiredsLang: [ "description"],
        requireds:[],
        afterCallFunction:this.props.getCompanyVAbout,
        afterParams:[],
        url:'admin-vabout'
      }
    })
  }

  componentDidMount(){
    this.props.getCompanyVAbout()
  }
  render() {
    const {companyVAbout} = this.props;
    return (
      <div className='p-[40px] w-full'>
        <Header btn={true} onClickBtn={this.openModal.bind(this, "", "", 1)} title="Voltmills Şirkət haqqında" />
        <div className='grid-full-250 grid grid-cols-2 mt-[20px]'>
          {
            companyVAbout?
                <Card1 
                  image={companyVAbout?.image_full_url}
                  onChangeLang={(id)=>this.openModal(companyVAbout, companyVAbout.translates.find(x=>x.lang_id==id), id)} 
                  title1={companyVAbout?.translate?.title}
                  deleteUrl={`admin-vabout/${companyVAbout?.id}`}
                  afterCallFunction={()=> this.props.getCompanyVAbout()}
                  deleteBtn={false}
                />:null
          }
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state)=>({
  companyVAbout: state.Data.companyVAbout
});
const mapDispatchToProps = {changeStateValue, getCompanyVAbout}
export default connect(mapStateToProps, mapDispatchToProps)(CompanyVAbout)
 